import {CallTypeKeywordContainer} from './keyword_text_form'
import { confirmPlus } from '../../common/custom_confirm';

export class CallTypeKeywordEditor extends HTMLElement {
  constructor(data, domain_id) {
    super();
    this.data = data;
    this.domain_id = domain_id;
    this.queue_id = this.data.site.call_processing_queue_type_id;
  }
  
  async connectedCallback() {
    this.refreshUI();
    await this.buildCallTypeGroups()

    this.querySelector("#save-keywords").addEventListener('click', function(e) {
      e.preventDefault();
      this.save()
    }.bind(this))

    this.querySelector(".step-cancel").addEventListener("click", this.cancelEdit.bind(this));
  }

  cancelEdit(e) {
    e.preventDefault();
    history.back();
  }

  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    this.querySelector('.errors').innerHTML = ``;
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })
    let isValid = true;
    this.querySelectorAll('call-type-keyword-container').forEach(elem => {
      if (! elem.validate()){
        isValid = false;
      }
    });

    return isValid;
  }

  async save() {
    const selected_location = this.getSelectedLocationData();

    // Need to verify that the logic here works.
    // if all are valid, then call getData
    const domain_id = selected_location.location_id;
    let data = {domain_id: domain_id, call_type_keywords_attributes: null};
    let callTypeKeywordsData = [];
    if(this.validate()){
      pageLoadingFrame("show")
      this.querySelectorAll('call-type-keyword-container').forEach(elem => {
        if (elem.validate()){
          const tempData = elem.getData();
          // Compare with the original data (this._data) to see if the original data
          // contained any keyword data that has been deleted. If so, then we need to 
          // add that keyword data to the data we are saving and mark it as deletable.
          const original_call_type_keywords = this._data.find(e => e.call_type_keyword_id === tempData.id)
          if (original_call_type_keywords){
            // Now see if any keywords are missing from the tempData keywords.
            // If so, it has been deleted, so we need to add data to mark it as deleted
            original_call_type_keywords.keywords.forEach(keyword => {
              if (keyword !== null) {
                const found_keyword = tempData.keyword_data_attributes.find(e => {
                  return(e.id === keyword.id)
                })

                // The original keyword is missing from the data we get back from the ui
                // so need to mark this as being deleted.
                if (! found_keyword){
                  tempData.keyword_data_attributes.push({id: keyword.id, _destroy: true})
                }
              }
            })
          }
          
          callTypeKeywordsData.push(tempData)
        }
      })

      data.call_type_keywords_attributes = callTypeKeywordsData

      const url = `/admin/domains/${domain_id}/call_type_keywords`
      let res = await fetch(url, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      }).catch(error => {
        pageLoadingFrame("hide")
        Common.notify('Unable to save changes because of an error.', 'danger');
        console.error('There was an error!', error);
      }); 

      pageLoadingFrame("hide")

      if (!res.ok) // or check for response.status
        throw new Error(res.statusText);
      
      let response = await res.json();
      if (response.success) {
        Common.notify('Call Type Keyword settings updated', 'success');
        this.connectedCallback();
      }
      else {
        Common.notify('Unable to save changes because of an error.', 'danger');
        pageLoadingFrame("hide")
      }
    }
  }

  refreshUI() {
  this.innerHTML = `
      <div class="row">
        <div class="col-md-12">
          <div id='lead_details_results'> 
            <div class="panel-heading">
              <h3>Call Type Keywords </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="container-fluid" >
            <div id="editor_form">
            </div>
          </div>

          <div class="col-sm-12">                                                                        
            <button class="btn btn-primary pull-right campaign-row-button" id="save-keywords" data-cy="save-keywords">Save</button>
            <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
          </div>

        </div>
      </div>
    `  
  }
  
  getSelectedLocationData(){
    const data = {location_id: this.domain_id, queue_id: this.queue_id};    
    return data;
  }
  
  async buildCallTypeGroups(){
    const selected_location = this.getSelectedLocationData();
    const editor_form = this.querySelector('#editor_form');
    if (! editor_form){
      console.log('editor form not found');
      return;
    }

    // Delete other form elements before creating new elements.
    let parent_call_types_container = this.querySelector('#call_types');
    if (parent_call_types_container){
      parent_call_types_container.remove()
    }
    
    parent_call_types_container = document.createElement('div');
    parent_call_types_container.setAttribute("id","call_types");
  
    const url = `/admin/domains/${selected_location.location_id}/location_keywords`
    let res = await fetch(url);
    let json = await res.json();
    this._data = json;
    if (json.length > 0){
      for(let el of json){
        el.domain_id = selected_location.location_id;
        el.processing_queue_type_id = selected_location.queue_id;
        const call_type_container = new CallTypeKeywordContainer(el);
        parent_call_types_container.append( call_type_container )
      }
    }
    else {
      // no data
      const call_type_container = document.createElement('div');
      call_type_container.className ="call_type_container";
        const title = document.createElement("h3");
        title.innerText = `No Call Type data found.`;
      call_type_container.append(title);
      parent_call_types_container.append( call_type_container )
    }
    
    editor_form.append(parent_call_types_container);
  }
}

customElements.define('call-type-keyword-editor', CallTypeKeywordEditor);
